import React, { useEffect } from 'react';
import styled from 'styled';

import { Confirm } from 'components/ui/modal';

import { connect } from 'containers/store'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared';

import { GettyActionCreators, actionCreators } from 'domains/org/getty/actions';
import { GettyStore } from 'domains/org/getty/store';

import { DeleteStopPointOfInterestRequest } from 'generated/mos/org/getty/audiomanagement';
import { StopPointOfInterest } from 'generated/mos/org/getty/audio'

import { getResolvedValue } from 'helpers/linkables'
import { pick } from 'helpers/core'
import { Status, statusSelector } from 'helpers/status';

import { stopSchema } from '../../../schemas/stop'

type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteStopPointOfInterestRequest'> &
  Pick<SharedActionCreators, 'toastNotification'>;

type ConnectedProps = Pick<GettyStore['getty'], 'stopPointOfInterestDelete' | 'stopPointOfInterestUpdate'>;

type DirectProps = {
  readonly historyPush: (id: string) => void;
  readonly projectId: string;
  readonly pointOfInterest: StopPointOfInterest.Entity | undefined;
  readonly moodId?: string;
  readonly onCancel: () => void;
};
type Props = ActionProps & ConnectedProps & DirectProps;

const PointOfInterestDeleteView = (props: Props) => {
  const {
    historyPush,
    projectId,
    gettyDeleteStopPointOfInterestRequest,
    toastNotification,
    stopPointOfInterestDelete,
    stopPointOfInterestUpdate,
    onCancel,
    moodId,
    pointOfInterest
  } = props

  const payload: DeleteStopPointOfInterestRequest.Entity = {
    ...DeleteStopPointOfInterestRequest.defaults,
    stopPointOfInterestRef: pointOfInterest && StopPointOfInterest.mustRef(pointOfInterest.ref)
  }

  const pointOfInterestName = pointOfInterest && pointOfInterest.stop && getResolvedValue(
    stopSchema.title.read(pointOfInterest.stop.title),
    statusSelector.hasData(stopPointOfInterestUpdate) ? stopPointOfInterestUpdate.data.resolvedValues : []
  )

  const modalMessage = (
    <>
      <p>Are you sure you want to permanently delete "{pointOfInterestName}"?</p>
    </>
  )

  const onConfirmDelete = () => {
    gettyDeleteStopPointOfInterestRequest(payload)
    historyPush(`/project/${projectId}/mood/${moodId}`)
  }

  useEffect(() => {
    if (stopPointOfInterestDelete.status === Status.Failed) {
      toastNotification({
        type: 'error',
        text: 'Could not delete point of interest',
      });
    }
  }, [stopPointOfInterestDelete.status]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Confirm
      title="Delete point of interest?"
      onClose={onCancel}
      message={modalMessage}
      confirmLabel="Delete"
      onConfirm={onConfirmDelete}
      danger
    />
  );
};

export const PointOfInterestDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => pick(store.getty, 'stopPointOfInterestDelete', 'stopPointOfInterestUpdate'),
  {
    ...pick(actionCreators, 'gettyDeleteStopPointOfInterestRequest'),
    ...pick(sharedActionCreators, 'toastNotification')
  }
)(PointOfInterestDeleteView)
